export const IntegrationsTypeDecorator = {
  url() {
    return `signup-hubspot/integrations`;
  },
  query() {
    return {};
  }
};